import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import { XStack, YStack } from '@tamagui/stacks';
import { Text } from '@tamagui/core';
import { ChevronLeft, MoreVertical, Banknote } from 'lucide-react-native';
import { useNavigation } from '@react-navigation/native';
import { AuthenticatedImage } from '@/components/AuthenticatedImage';
import { COLORS } from '@/constants/colors';

type ChatHeaderProps = {
  name: string;
  imageUri: string;
  isDark?: boolean;
};

const ChatHeader = React.memo<ChatHeaderProps>(({ name, imageUri, isDark }) => {
  const navigation = useNavigation();
  const bgColor = isDark ? COLORS.BLACK : COLORS.WHITE;
  const textColor = isDark ? COLORS.WHITE : COLORS.DARK_TEXT;

  return (
    <XStack
      alignItems="center"
      justifyContent="space-between"
      paddingHorizontal="$4"
      paddingVertical="$3"
      backgroundColor={bgColor}
      style={styles.header}
    >
      {/* Left: Back Button + Avatar + Name */}
      <XStack alignItems="center" gap="$3" flex={1}>
        <Pressable onPress={() => navigation.goBack()}>
          <ChevronLeft size={28} color={textColor} strokeWidth={2} />
        </Pressable>
        
        {imageUri ? (
          <AuthenticatedImage uri={imageUri} style={styles.avatar} />
        ) : (
          <YStack style={[styles.avatar, styles.avatarPlaceholder]} justifyContent="center" alignItems="center">
            <Text color={COLORS.WHITE} fontSize={16} fontWeight="600">
              {name.charAt(0).toUpperCase()}
            </Text>
          </YStack>
        )}
        
        <Text fontSize={18} fontWeight="600" color={textColor}>
          {name}
        </Text>
      </XStack>

      {/* Right: Cash + More */}
      <XStack alignItems="center" gap="$2">
        <Pressable style={styles.iconButton}>
          <Banknote size={28} color={textColor} />
        </Pressable>
        <Pressable style={styles.iconButton}>
          <MoreVertical size={28} color={textColor} />
        </Pressable>
      </XStack>
    </XStack>
  );
});

const styles = StyleSheet.create({
  header: {
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(0,0,0,0.1)',
  },
  avatar: {
    width: 40,
    height: 40,
    borderRadius: 20,
  },
  avatarPlaceholder: {
    backgroundColor: COLORS.PRIMARY,
  },
  iconButton: {
    padding: 8,
  },
});

ChatHeader.displayName = 'ChatHeader';

export default ChatHeader;


